module.exports = __webpack_public_path__ + "img/vipTipImg.3228b085.png";